// extracted by mini-css-extract-plugin
export default {"container":"Login_container__GwQcn","form":"Login_form__YOTdw","registerBox":"Login_registerBox__7-swa","header":"Login_header__B9MGH"};